import { apiFetch } from "./api";
import { stringifySnake } from "./serialization";

export function fetchExternalAssets() {
  return apiFetch("/api/v1/external-assets");
}

export function createExternalAsset(payload) {
  return apiFetch("/api/v1/external-assets", {
    method: "POST",
    body: stringifySnake(payload),
  });
}

export function updateExternalAsset(id, payload) {
  return apiFetch(`/api/v1/external-assets/${id}`, {
    method: "PATCH",
    body: stringifySnake(payload),
  });
}

export function deleteExternalAsset(id) {
  return apiFetch(`/api/v1/external-assets/${id}`, { method: "DELETE" });
}
